import { render, staticRenderFns } from "./MpTencentPrediction.vue?vue&type=template&id=1876d38a&scoped=true&"
import script from "./MpTencentPrediction.vue?vue&type=script&lang=js&"
export * from "./MpTencentPrediction.vue?vue&type=script&lang=js&"
import style0 from "./MpTencentPrediction.vue?vue&type=style&index=0&id=1876d38a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1876d38a",
  null
  
)

export default component.exports